import { getTrainerConfig, getTrainerBannerConfig, getVerificationCode } from '@/request/api/trainerTeam'
import { TeacherListItem, VerificationCode } from '@/interface/trainer'
import { IBannerListItem } from '@/interface'
import { Commit } from 'vuex'

const state = {
  trainerPageList: [] as TeacherListItem[],
  trainerBannerList: [] as IBannerListItem[],
  verificationCode: {} as VerificationCode
}

const trainerStore = {
  namespaced: true,
  state,
  actions: {
    async initTrainerPageInfo ({ commit }: { commit: Commit }, payload: { releaseStatus: string }) {
      const res = await getTrainerConfig(payload)
      console.log('wtf?', res)
      commit('setTrainerPageInfo', res.data || [])
    },
    async initTrainerBannerInfo ({ commit }: { commit: Commit }, payload: { typeList: string[] }) {
      const res = await getTrainerBannerConfig(payload)
      commit('setTrainerBannerInfo', res.data || [])
    },
    async initVerificationCode ({ commit }: { commit: Commit }) {
      const res = await getVerificationCode()
      commit('setVerificationCode', res.data || {})
    }
  },
  mutations: {
    setTrainerPageInfo (state: TrainerState, list: TeacherListItem[]): void {
      state.trainerPageList = list
    },
    setTrainerBannerInfo (state: TrainerState, list: IBannerListItem[]): void {
      state.trainerBannerList = list
    },
    setVerificationCode (state: TrainerState, list: VerificationCode): void {
      state.verificationCode = list
    }
  }
}

export type TrainerState = typeof state

export {
  trainerStore
}
